import DecimalSetting from "./DecimalSetting.vue";

export default DecimalSetting